import { render, staticRenderFns } from "./CommonMessageTemplate.vue?vue&type=template&id=21133a7d&scoped=true"
import script from "./CommonMessageTemplate.vue?vue&type=script&lang=js"
export * from "./CommonMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./CommonMessageTemplate.vue?vue&type=style&index=0&id=21133a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21133a7d",
  null
  
)

export default component.exports